import { Header, Footer, AppMain } from "./components";
export default {
  name: "Layout",
  components: {
    Header: Header,
    Footer: Footer,
    AppMain: AppMain
  },
  methods: {}
};